<!--TODO: cambiar ngStyle para cogerlo desde ts -->
<ng-container *ngIf="noticias">
  <div class="row columns-2-multirow">
    <div class="columna-izquierda">
      <ng-container *ngFor="let item of noticias | slice: 0 : 6; trackBy: item; let i = index">
        <article class="noticia" [ngClass]="idStart == 1 ? 'first-new' : ''" ngClass="{{ item?.colorFondo ? 'noticia-color' : '' }}" [ngStyle]="item?.colorFondo && { 'background-color': item?.colorFondo }">
          <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
            <ng-container *ngIf="!(item?.portada_iframe === '1')">
              <div class="contNoticia">
                <!-- <div class=" et-xs"  [routerLink]="['/noticias', item?.idVideo, item?.tituloVideo | kebabCase]" *ngIf="item?.texto_etiqueta && i != 2"  [ngClass]="item?.class_etiqueta"
            [ngStyle]="{'color':  item?.color_texto_etiqueta,
                        'background-color':  item?.color_fondo_etiqueta}">
              <span class="etiquetaTxt">{{item?.texto_etiqueta}}</span>
            </div> -->
                <ng-container *ngIf="i != 2">
                  <app-skeleton-image [ngClass]="i % 2 == 0 ? 'float-left' : 'float-left'" [created]="item?.fechaCreacion" [size]="175" width="100%" height="100%" [src]="item?.urlGenerica" [lazy]="true" [alt]="item?.tituloVideo"></app-skeleton-image>
                </ng-container>
                <div class="flexTitle">
                  <div class="bloque-foto-gris">
                    <ng-container *ngIf="i == 2">
                      <app-skeleton-image class="imagen_completa" [created]="item?.fechaCreacion" [size]="475" [src]="item?.urlGenerica" [lazy]="true" [alt]="item?.tituloVideo"></app-skeleton-image>
                    </ng-container>
                    <ng-container *ngIf="item?.tituloInvisible == '0'">
                      <h2 class="header-article" [ngClass]="i % 2 == 0 && i != 2 ? 'text-left' : 'text-left'" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                        <div class="tit_com">
                          <ng-container *ngIf="!item?.tituloVideoSecundario">
                            {{ item?.tituloVideo }}
                          </ng-container>
                          <ng-container *ngIf="item?.tituloVideoSecundario">
                            {{ item?.tituloVideoSecundario }}
                          </ng-container>
                        </div>
                      </h2>
                    </ng-container>
                  </div>

                  <div class="footer-article text-center">
                    <ng-container *ngIf="!item?.noticias_relacionadas">
                      <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && item?.firma_externa">
                        <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.firma_externa }}</span>
                      </ng-container>

                      <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && !item?.firma_externa">
                        <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.nombre_autor }}</span>
                      </ng-container>

                      <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                        <ng-container && !item?.firma_externa>
                          <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ autorEmpresa }}</span>
                        </ng-container>
                      </ng-container>
                      <span [ngStyle]="item?.colorFondo && { color: item?.colorFecha }">{{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}</span>
                    </ng-container>

                    <ng-container *ngIf="item?.noticias_relacionadas">
                      <ng-container *ngFor="let relacionada of item?.noticias_relacionadas; trackBy: relacionada">
                        <div #nombreAutor class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                          <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]">
                            {{ relacionada.titulo }}
                          </a>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="item?.portada_iframe_url && item?.portada_iframe === '1'">
              <ng-container *ngIf="item?.tituloInvisible == '0'">
                <h2 class="header-article" [ngClass]="i % 2 == 0 && i != 2 ? 'text-left' : 'text-left'" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideosecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </ng-container>
              <iframe [src]="item?.portada_iframe_url | safeResourceUrl" width="100%" height="170"></iframe>
            </ng-container>
          </a>
        </article>
      </ng-container>
    </div>

    <div class="columna-derecha">
      <ng-container *ngFor="let item of noticias | slice: 6 : 7; trackBy: item; let i = $index">
        <article class="noticia_alter noticia" ngClass="{{ item?.colorFondo ? 'noticia-color' : '' }}" [ngStyle]="item?.colorFondo && { 'background-color': item?.colorFondo }">
          <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
            <ng-container *ngIf="!(item?.portada_iframe === '1')">
              <div style="position: relative; width: 100%">
                <ng-container *ngIf="item?.texto_etiqueta">
                  <div
                    class="etiqueta et-m"
                    [ngClass]="item?.class_etiqueta"
                    [ngStyle]="{
                      color: item?.color_texto_etiqueta,
                      'background-color': item?.color_fondo_etiqueta,
                    }"
                  >
                    <span class="etiquetaTxt">{{ item?.texto_etiqueta }}</span>
                  </div>
                </ng-container>
                <app-skeleton-image [created]="item?.fechaCreacion" [size]="450" [src]="item?.urlGenerica" [lazy]="true" [alt]="item?.tituloVideo"></app-skeleton-image>
                <ng-container *ngIf="item?.hasVideo">
                  <app-animacion-video style="top: 0" class="animacion-video" [videoCargando]="false" [click]="false"></app-animacion-video>
                </ng-container>
              </div>
              <ng-contaienr *ngIf="item?.tituloInvisible == '0'">
                <h2 class="header-article" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideoSecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </ng-contaienr>
              <p class="description-article" [innerHTML]="item?.entradillaVideo" [ngStyle]="item?.colorEntradilla && { color: item?.colorEntradilla }"></p>
              <div class="footer-article" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                <ng-container *ngIf="!item?.noticias_relacionadas">
                  <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0">
                    <span #nombreAutor class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.nombre_autor }}</span>
                  </ng-container>

                  <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                    <span #nombreAutor class="canal-noticia">{{ autorEmpresa }}</span>
                  </ng-container>
                  <span [ngStyle]="item?.colorFondo && { color: item?.colorFecha }">{{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}</span>
                </ng-container>
                <ng-container *ngIf="item?.noticias_relacionadas">
                  <ng-container *ngFor="let relacionada of item?.noticias_relacionadas; trackBy: relacionada">
                    <div #nombreAutor class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                      <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]">
                        {{ relacionada.titulo }}
                      </a>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="item?.portada_iframe_url && item?.portada_iframe === '1'">
              <ng-container *ngIf="item?.tituloInvisible == '0'">
                <h2 class="header-article" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                  <ng-container *ngIf="!item?.tituloVideoSecundario">
                    {{ item?.tituloVideo }}
                  </ng-container>
                  <ng-container *ngIf="item?.tituloVideoSecundario">
                    {{ item?.tituloVideoSecundario }}
                  </ng-container>
                </h2>
              </ng-container>
              <iframe [src]="item?.portada_iframe_url | safeResourceUrl" width="100%" height="170"></iframe>
            </ng-container>
          </a>
        </article>
      </ng-container>

      <app-fila-dos-columnas class="bloque-2-columnas gris_2_multi" [noticias]="noticias | slice: 7 : 9" [idStart]="idStart + 7" [lcp]="true" [autorEmpresa]="autorEmpresa"></app-fila-dos-columnas>
    </div>
  </div>
</ng-container>
